var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48 22V15.52H7.656C8.04533 15.52 8.36533 15.5947 8.616 15.744C8.86667 15.888 9.05333 16.1013 9.176 16.384C9.29867 16.6613 9.36 17 9.36 17.4C9.36 17.9013 9.27733 18.2853 9.112 18.552C8.94667 18.8133 8.72267 18.9947 8.44 19.096C8.15733 19.1973 7.84 19.248 7.488 19.248H6.912V22H5.48ZM6.912 18.248H7.392C7.568 18.248 7.70133 18.216 7.792 18.152C7.88267 18.088 7.94133 17.992 7.968 17.864C8 17.736 8.016 17.5733 8.016 17.376C8.016 17.2107 8.00267 17.0667 7.976 16.944C7.95467 16.816 7.89867 16.7147 7.808 16.64C7.71733 16.5653 7.576 16.528 7.384 16.528H6.912V18.248ZM10.5303 22V15.52H12.1703C12.7356 15.52 13.1756 15.592 13.4903 15.736C13.805 15.8747 14.0263 16.096 14.1543 16.4C14.2823 16.6987 14.3463 17.088 14.3463 17.568V19.92C14.3463 20.4053 14.2823 20.8027 14.1543 21.112C14.0263 21.416 13.805 21.64 13.4903 21.784C13.181 21.928 12.7463 22 12.1863 22H10.5303ZM11.9623 21.008H12.1863C12.405 21.008 12.5623 20.976 12.6583 20.912C12.7543 20.848 12.813 20.752 12.8343 20.624C12.861 20.496 12.8743 20.336 12.8743 20.144V17.32C12.8743 17.128 12.8583 16.9733 12.8263 16.856C12.7996 16.7387 12.7383 16.6533 12.6423 16.6C12.5463 16.5467 12.3916 16.52 12.1783 16.52H11.9623V21.008ZM15.6978 22V15.52H18.4978V16.488H17.1298V18.12H18.3218V19.12H17.1298V22H15.6978Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.8a1e4b92602e840ab13cd6e4c4efae5e.svg";
export { ForwardRef as ReactComponent };